import React, { Component, useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import "../translations/i18n";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Message from "../Components/message";
import { Form } from 'rsuite';
import { ActivateUser } from '../Redux/actions/userActions';

const Activate = () => {
  const translations = useSelector(state => state.translationReducer);
  const [translation, setTranslation] = useState([]);
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(['languaje']);
  const msgRef = React.useRef();
  let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [msgInfo, setMsgInfo] = useState(null);


  const toPage = (page) => {
    navigate(page)
  }



  useEffect(() => {
    setTranslation(translations.data);
  }, [translations]);


  useEffect(() => {
      dispatch(ActivateUser(searchParams.get("key"), function (response) {
        setMsgInfo(response);
      }));
  }, []);

  return (
    <>
      <Header />
      <Form>
        <div className="container">
          <div className="row mt-5">
              <div className="row justify-content-md-center">
                <div className="row  mt-2 center">
                      <div className="col-md-3"></div> 
                      <div className="col-md-6 text-center" style={{minHeight:"400px"}}>
                            {msgInfo!=null && 
                            <>  
                              {msgInfo?
                                <>
                                  <div className="alert alert-info">
                                      <strong>Bienvenido!</strong> Su usuario se ha activado de forma exitosa
                                  </div>  
                                    <button type="button" onClick={(event)=>{ 
                                      toPage("/Login");
                                    }} className="btn btn-primary">Acceder</button> 
                                  </>
                                  :
                                  <div className="alert alert-danger">
                                      <strong>Error!</strong> Usuario o código de caso no encontrado.
                                  </div>                                 
                              }
                            </>
                            }
                      </div>
                      <div className="col-md-3"></div> 
              </div>
             </div>
            </div>
          </div>
      </Form>
      <Message ref={msgRef}></Message>
      <Footer />
    </>
  );
}

export default Activate;